module.exports = __webpack_public_path__ + "media/bottle_hall.698e04ff.wav";